import moment, { Moment } from "moment"

export default function tratativaDeDatas(valor: string | Moment | null | undefined, diaDaSemana?: boolean, formato?: string): string {
    if (valor === "0000-00-00" || valor === null || valor === undefined) return "-";

    const format = formato || "DD/MM/YYYY";

    let dataFormatada: string;
    if (moment.isMoment(valor)) {
        dataFormatada = valor.format(format);
    } else {
        dataFormatada = moment(valor).format(format);
    }

    if (diaDaSemana) {
        const nomeDiaDaSemana = moment(valor).format("ddd");
        return `${dataFormatada} ${nomeDiaDaSemana.charAt(0).toUpperCase() + nomeDiaDaSemana.slice(1)}`; 
    }

    return dataFormatada; 
}